import { StorageQuotaStatus } from 'app/components/Storage/types';
import { config } from 'config';
import { Address } from 'types/profile';
import { DDL } from 'types/general.types';

export const parseBase64 = (base64?: string) => {
  try {
    return base64 && JSON.parse(decodeURIComponent(atob(base64)));
  } catch (e) {
    return undefined;
  }
};

export const ensureDomain = (url: string) =>
  Boolean(url.match(/^https:\/\/api(.[-a-z0-9]+){0,2}.sessionstudio.com\//));

const tokenKey = 'authToken';
const userGuidKey = 'userGuid';
const storageQuotaStatusKey = 'storageQuotaStatus';

export const getToken = () => window.localStorage.getItem(tokenKey);
export const setToken = (tokenValue: string) =>
  window.localStorage.setItem(tokenKey, tokenValue);
export const deleteToken = () => window.localStorage.removeItem(tokenKey);

export const setUserGuid = (userGuid: string) =>
  window.localStorage.setItem(userGuidKey, userGuid);

export const deleteUserGuid = () => {
  try {
    return window.localStorage.removeItem(userGuidKey);
  } catch (e) {
    return null;
  }
};
export const getUserGuid = () => window.localStorage.getItem(userGuidKey);

export const isWebClient = !config.isElectronBuild;

export const isCookieEnabled = () => {
  try {
    localStorage.getItem('');
    document.cookie = 'cookietest=1';
    const isNotEmpty = document.cookie !== '';
    document.cookie = 'cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT';
    return isNotEmpty;
  } catch (e) {
    return false;
  }
};

const getStorageQuotaStatus = () =>
  window.localStorage.getItem(storageQuotaStatusKey);

export const setStorageQuotaStatus = (
  storageQuotaStatus?: StorageQuotaStatus
) => {
  if (storageQuotaStatus) {
    window.localStorage.setItem(storageQuotaStatusKey, storageQuotaStatus);
  }
};

const getEmptyPinSectionDismissedKey = (profileGuid = '') =>
  `empty_pin_section_dismissed_${profileGuid}`;

export const isEmptyPinSectionDismissed = (currentProfileGuid = '') =>
  Boolean(
    window.localStorage.getItem(
      getEmptyPinSectionDismissedKey(currentProfileGuid)
    )
  );

export const dismissEmptyPinSection = (currentProfileGuid = '') =>
  window.localStorage.setItem(
    getEmptyPinSectionDismissedKey(currentProfileGuid),
    'true'
  );

export const showStoragePopUp = (
  quotaStatus?: StorageQuotaStatus,
  enforceLimit?: boolean,
  usedBytesIncreased?: boolean
) =>
  enforceLimit &&
  usedBytesIncreased &&
  getStorageQuotaStatus() !== 'OverLimit' &&
  quotaStatus === 'OverLimit';

export const formatCountryLocation = (countriesDDL: DDL, address: Address) => {
  const country =
    countriesDDL[address?.countryCode || '']?.name || address?.countryCode;
  const city = address?.city;

  if (!country && city) {
    return city;
  }
  if (country && !city) {
    return country;
  }
  if (country && city) {
    return `${country}, ${city}`;
  }
  return '';
};

export const findMatchPageTitle = (matches?: any[]) => {
  if (!matches) {
    return undefined;
  }
  return matches.reverse().find((match) => match?.handle?.pageTitle)?.handle
    ?.pageTitle;
};
